import DOMPurify from 'dompurify';
import React, { useMemo } from 'react';

export interface SanitizedHTMLProps {
  rawHTML: string;
}

/**
 * Safely display user-generated HTML content
 */
export default function SanitizedHTML({ rawHTML }: SanitizedHTMLProps) {
  const sanitizedHTML = useMemo(
    () => DOMPurify.sanitize(rawHTML, { USE_PROFILES: { html: true } }),
    [rawHTML]
  );
  // We disable the rule because we have sanitized it above!
  // eslint-disable-next-line @eslint-react/dom/no-dangerously-set-innerhtml
  return <div dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />;
}
